import React from 'react';

import type { TypographyProps } from './types';
import { StyledSubHeading } from './StyledComponents';

export const SubHeading = ({
  children,
  testID,
  ...rest
}: TypographyProps): React.ReactElement => {
  return (
    <StyledSubHeading data-testid={testID} {...rest}>
      {children}
    </StyledSubHeading>
  );
};
